import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../config/msalConfig';

let msalInstance: PublicClientApplication | null = null;

const getMsalInstance = (): PublicClientApplication => {
	if (!msalInstance) {
		msalInstance = new PublicClientApplication(msalConfig);
	}
	return msalInstance;
};

export const getUserEmail = (): string | null => {
	try {
		const instance = getMsalInstance();
		const account = instance.getActiveAccount();
		return account?.username || null;
	} catch (error) {
		console.error('Error getting user email:', error);
		return null;
	}
};

export const getUserId = (): string => {
	const email = getUserEmail();
	return email || 'unknown-user';
};
